module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data && (_vm.data.heading || _vm.data.description)) ? _c('div', {
    staticClass: "pictured-section",
    class: {
      'pictured-section--dark': _vm.dark
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.image.url) ? _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12 pictured-section__image notched notched__enabled notched__outside notched__mobile-outside notched--middle notched--mobile-middle notched--dark-grey",
    style: ({
      'background-image': 'url( ' + _vm.data.image.url + ' )'
    })
  }, [_c('div', {
    staticClass: "notched-helper"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-l-8 col-m-8 col-s-12 pictured-section__content"
  }, [(_vm.data.description) ? _c('div', {
    staticClass: "pictured-section__description",
    domProps: {
      "innerHTML": _vm._s(_vm.data.description)
    }
  }) : _vm._e()])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca9730d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PicturedSection.vue
// module id = 315
// module chunks = 0